import { Autocomplete, TextField } from "@mui/material";
import classes from './DropdownSearch.module.scss';
import { DropdownSearchProps } from "../../interfaces/props/DropdownSearchProps";

const DropdownSearch = ({ options, setValue, value, onInputChange, placeholder }: DropdownSearchProps) => {
  return <Autocomplete
    className={`${classes.search} ms-1 ms-md-0`}
    classes={{ option: classes['option-color'], listbox: `${classes['listbox-height']} scrollbar`}}
    disablePortal
    options={options}
    getOptionLabel={(option) => option.name}
    renderInput={(params) => (
      <TextField {...params} placeholder={`${placeholder}`} className='p-0'
        InputProps={{
          ...params.InputProps,
          classes: {
            notchedOutline: classes['border-autocomplete']
          },
        }}
      />
    )}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    limitTags={1}
    onChange={setValue}
    value={value}
    onInputChange={onInputChange}
  />
};

export default DropdownSearch;
